import React from 'react';
import '../CSS/App.css';
import '../CSS/Contact.css';

const Contact = () => {
    return (
      <div>
        <p className='title'>Contact</p>
        <div className="contact-container">
            <div className="contact-info">
                <a className='contact' href="mailto:jgcabrera2004@gmail.com">jgcabrera2004@gmail.com</a>

                <div className='social-links'>
                    <p>Connect with me:</p>
                    <ul>
                        <li><a href="https://github.com/jermy79" target="_blank" rel="noopener noreferrer">GitHub</a></li>
                        <li><a href="https://www.linkedin.com/in/jeremygcabrera/" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
                    </ul>
                </div>

                <p className='location'>Based in Los Angeles, CA</p>
            </div>
        </div>
      </div>
    );
};

export default Contact;
